import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "persistent": "",
      "width": "300px"
    },
    model: {
      value: _vm.csvDownloadModal,
      callback: function ($$v) {
        _vm.csvDownloadModal = $$v;
      },
      expression: "csvDownloadModal"
    }
  }, [_c(VCard, [_c(VRow, {
    staticClass: "ma-0",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "my-4 px-0 mb-4"
  }, [_c('p', [_vm._v(_vm._s(_vm.csvDownloadModalText))]), _c('p', [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-mug-hot")])], 1), _c(VProgressCircular, {
    attrs: {
      "size": 40,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })], 1)], 1)], 1)], 1), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('accMgmt.tenant.systemLogsPageHeader'),
      "subtitle": _vm.$i18n_t('accMgmt.tenant.systemLogsPageHeaderInfoText')
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pt-0 mt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "buttons": _vm.actionButtons
    },
    on: {
      "runCSVExport": _vm.runCSVExport
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "append-icon": "fal fa-search",
      "single-line": "",
      "hide-details": "",
      "clearable": "",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dateTime-picker', {
    attrs: {
      "isRange": "",
      "initialRange": "now-24h"
    },
    on: {
      "date:picked": _vm.dateTimeChange
    }
  })], 1)], 1), _c(VCardText, [_c(VDataTable, {
    attrs: {
      "headers": _vm.tableLocalizations.headers,
      "items": _vm.items,
      "search": _vm.search,
      "loading": _vm.tableLoading,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "footer-props": _vm.tableLocalizations.tableFooterProps,
      "color": _vm.color,
      "expanded": _vm.expanded,
      "item-key": "id",
      "page": _vm.tableOptions.page
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', {
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.expanded.length == 0 ? [props.item] : [];
            }
          }
        }, [_c('td', {
          attrs: {
            "width": "200"
          }
        }, [_vm._v(_vm._s(_vm.date(props.item.createdAt, true)))]), _c('td', {
          attrs: {
            "width": "200"
          }
        }, [_vm._v(_vm._s(props.item.tenantName))]), _c('td', {
          attrs: {
            "width": "200"
          }
        }, [_vm._v(_vm._s(props.item.type))]), _c('td', [_vm._v(_vm._s(props.item.action))])])];
      }
    }, !_vm.tableLoading ? {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.noData')) + "\n              ")])];
      },
      proxy: true
    } : null, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": "4"
          }
        }, [_c(VRow, [_c(VCol, {
          attrs: {
            "cols": "6",
            "sm": "4"
          }
        }, [_c('pre', [_vm._v(_vm._s(props.item.properties))])])], 1)], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                  " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n                ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };